
import Vue from 'vue'
import App from './App.vue'

// import "./assets/js/rem";
import allApi from "./assets/js/api";
import commin from "./assets/js/commin";
import rsa from "./assets/js/rsa";
import md5 from 'js-md5';
import {router} from "./assets/js/router";
import store from "./assets/js/store";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { DatePicker,Table,TableColumn,Input,Button } from 'element-ui'; 


import 'swiper/dist/css/swiper.css';
import "./assets/result.css";
import "./assets/theme/bass.scss";
import animate from "animate.css";
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(animate);
Vue.use(VueAwesomeSwiper, /* { default global options } */);
Vue.use(DatePicker);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Input);
Vue.use(Button);

Vue.config.productionTip = true;

Vue.prototype.allApi = allApi;
Vue.prototype.commin = commin;
Vue.prototype.$rsa = rsa;
Vue.prototype.$md5 = md5;
Vue.prototype.Bus = new Vue();

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
